<template>
  <div>
    <hr class="separator-slim mx-6" v-if="isShowingDestinationFilter">
    <div class="search-filter-box p-6" v-if="isShowingDestinationFilter">
      <h4 class="fs-20 font-medium mb-4">
        Destinations
      </h4>

      <template v-if="destination.type === 'country'">
        <template v-for="province in destination.children">
          <checkbox :key="province.id"
                    v-model="options[`opt${province.id}`]"
                    v-show="isDestinationVisible(province.id)"
                    :partial="isPartialSelected(province.id)"
                    @input="handleProvinceChanged(province.id)">
            <div class="font-medium" v-html="province.name"></div>
          </checkbox>
          <template v-for="destination in province.children">
            <checkbox :key="destination.slug"
                      v-show="isDestinationVisible(destination.id)"
                      class="ml-4"
                      v-model="options[`opt${destination.id}`]"
                      @input="handleDestinationChanged(province.id)">
              <div v-html="destination.name"></div>
            </checkbox>
          </template>
        </template>
      </template>
      <template v-else-if="destination.type === 'province'">
        <template v-for="destination in destination.children">
          <checkbox :key="destination.slug"
                    v-show="isDestinationVisible(destination.id)"
                    v-model="options[`opt${destination.id}`]">
            <div v-html="destination.name"></div>
          </checkbox>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'
import { mapState } from 'vuex'
import {
  allDestinationItems
} from '../../../helpers/searchHelpers'

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox  },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  computed: {
    ...mapState(['destination', 'statistics']),
    isShowingDestinationFilter () {
      if (this.destination.type === 'destination') {
        return false
      }

      if (this.statistics === null) {
        return false
      }

      return true
    }
  },
  methods: {
    loadOptions () {
      const { filters, destination } = this.$store.state
      const selectingDestinations = filters.destinations.split(',')

      const options = allDestinationItems
        .map(entry => entry.id)
        .reduce((obj, id) => {
          const isSelected = selectingDestinations.includes(id)

          return Object.assign({ [`opt${id}`]: isSelected }, obj)
        }, {})

      return options
    },
    isPartialSelected (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      if (province.children.every(dest => this.options[`opt${dest.id}`])) {
        return false
      }

      return province.children.some(dest => this.options[`opt${dest.id}`])
    },
    handleProvinceChanged (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      for (const dest of province.children) {
        if (this.options[`opt${provinceId}`]) {
          this.options[`opt${dest.id}`] = true
        }
        else {
          this.options[`opt${dest.id}`] = false
        }
      }
    },
    handleDestinationChanged (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      if (province.children.every(dest => !this.options[`opt${dest.id}`])) {
        this.options[`opt${provinceId}`] = false
      }
      else if (province.children.every(dest => this.options[`opt${dest.id}`])) {
        this.options[`opt${provinceId}`] = true
      }
    },
    isDestinationVisible (destinationId) {
      return get(this.statistics, ['visibleDestinations', destinationId], false) === true
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        let newValue = []

        for (const opt in options) {
          if (options[opt]) {
            const id = Number(opt.split('opt')[1])

            if (this.isDestinationVisible(id)) {
              newValue.push(id)
            }
          }
        }

        this.$store.commit('setFilter', {
          name: 'destinations',
          value: newValue.join(',')
        })
        this.$store.dispatch('loadSuppliers')
      }
    }
  }
}
</script>
